'use strict';

var config = {
  disabled: false
};

module.exports = config;
